import { toast } from "react-toastify";
import CheckboxComp from "themes/elements/Checkbox";
import ModalComp from "themes/elements/Modal";
import TextAreaComp from "themes/elements/TextArea";
import ModalFooter from "../modalFooter";

function RejectNotification({
  isLoading,
  formData,
  setFormData,
  open,
  setOpen,
  onSubmit,
}) {
  const handleSubmit = () => {
    if (!formData.remark || formData.remark.trim() === "") {
      toast.warning("Please provide a reason for rejection.");
      return;
    }
    onSubmit();
  };

  return (
    <ModalComp
      title="Reject this notification?"
      footer={
        <ModalFooter
          handlePrimaryBtn={() => setOpen(false)}
          primaryBtnvariant="secondary"
          primaryBtnText="Cancel"
          secondaryBtnloading={isLoading}
          handleSecondaryBtn={handleSubmit}
          secondaryBtnText="Submit"
        />
      }
      open={open}
      setOpen={setOpen}
    >
      <div className="flex flex-column gap-4">
        <TextAreaComp
          maxValue={150}
          value={formData.remark}
          onChange={(e) => {
            setFormData((prev) => ({
              ...prev,
              remark: e.target.value,
            }));
          }}
          label={
            <>
              Reason for Rejection
            </>
          }
          placeholder="Enter a clear and concise reason for rejecting this notification..."
        />
        <CheckboxComp
          isChecked={formData.allow_resubmission_flg}
          onChange={(value) => {
            setFormData((prev) => ({
              ...prev,
              allow_resubmission_flg: value,
            }));
          }}
          label="Allow resubmission"
        />
      </div>
    </ModalComp>
  );
}

export default RejectNotification;
